export const handleWidth: IHandleWidth = 
(
  isTablet 
) => {
  if (isTablet) return "100%";

  return "calc(38.5% - 1.5rem)";
};


type IHandleWidth = (
    isTablet:boolean, 
) => string
